import styled from 'styled-components';

import { rem, flex } from '../../../core';

const FormRowStyled = styled.div.attrs({
  className: 'component__formRow',
})`
  margin-right: -${rem(4)};
  margin-left: -${rem(4)};
  ${flex('row', 'flex-start', 'flex-start')};
  flex-wrap: wrap;
  > div {
    margin-right: ${rem(4)};
    margin-left: ${rem(4)};
    flex: 1;
  }
`;

export default FormRowStyled;
